import { render, staticRenderFns } from "./EditInformGroupDialog.vue?vue&type=template&id=05d15f4e&scoped=true"
import script from "./EditInformGroupDialog.vue?vue&type=script&lang=js"
export * from "./EditInformGroupDialog.vue?vue&type=script&lang=js"
import style0 from "./EditInformGroupDialog.vue?vue&type=style&index=0&id=05d15f4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d15f4e",
  null
  
)

export default component.exports